import React, { useEffect, useState } from "react";
import logo from "../assets/img/logo_arabics.svg";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ReloadTrue } from "../redux/rootSlice";
const Header = () => {
  const dispatch = useDispatch();
  const storedTheme = localStorage.getItem("theme");
  const [isDarkTheme, setisDarkTheme] = useState(storedTheme === "dark");

  const toggleTheme = () => {
    const newTheme = isDarkTheme ? "light" : "dark";
    localStorage.setItem("theme", newTheme);
    dispatch(ReloadTrue());
    setisDarkTheme(!isDarkTheme);
  };

  useEffect(() => {
    const storedTheme = localStorage.getItem("theme");
    setisDarkTheme(storedTheme === "dark");
  }, []); // Empty dependency array ensures this effect runs once on component mount

  return (
    <div className="bg-primary dark:bg-bg-dark flex justify-between px-4">
      <Link to="./admin">
        <img
          src={logo}
          alt="logo"
          className="h-20 rotate-2 p-2.5 hover:cursor-pointer"
        />
      </Link>

      <div
        className="theme-switch-container theme-container shadow-dark"
        onClick={toggleTheme}>
        <img
          className="p-3"
          src={
            isDarkTheme
              ? "https://www.iconpacks.net/icons/2/free-sun-icon-1845-thumb.png"
              : "https://cdn-icons-png.flaticon.com/512/180/180700.png"
          }
          alt=""
        />
      </div>
    </div>
  );
};

export default Header;
